import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ServiceHistoryTable, SearchBar } from './components';
import { Add as AddIcon } from '@mui/icons-material';
import { GlobalButton, NavigateLinks, Authorize } from '@/components';
import { childrenInventoryPageBreadcrumbs } from '../../config';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { useServiceHistoryFilter } from './hooks';
import { ServiceHistoryFilter } from './models';
import { ROLES } from '@/components/security/AppRoles';

import styles from './ServiceHistory.module.css';

export const ServiceHistory = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => childrenInventoryPageBreadcrumbs(navigate),
    []
  );

  const { filter, setFilter, initialFilter } = useServiceHistoryFilter();

  const handleServiceHistorySearch = (filters: ServiceHistoryFilter) => {
    setFilter(filters);
  };

  return (
    <section className={styles.container}>
      <NavigateLinks
        actualPage='Historial de servicios'
        breadcrumbs={breadcrumbs}
      />
      <Authorize permission={ROLES.INVENTORY.admin}>
        <div className={styles.actions}>
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={() => navigate('create')}
          >
            <AddIcon />
            Agregar service
          </GlobalButton>
        </div>
      </Authorize>
      <SearchBar onSearch={handleServiceHistorySearch} initialFilter={initialFilter} />
      <ServiceHistoryTable serviceHistoryFilter={filter} />
    </section>
  );
};

export default ServiceHistory;
